import { OpenExternalLink } from 'icons';
import { rem } from 'polished';
import { styled } from 'styles';

export const ExternalLinkIcon = styled(OpenExternalLink).attrs(() => ({
  primaryColor: 'currentColor',
}))`
  margin-left: ${rem(4)};
`;
